import { IImage } from '@belong/types/index';
import { FImage } from '../image.factory';

/** @deprecated please use FMoleculeMediaCaptionBlock */
export const FMoleculeAsset = (data: any): IImage => {
  return FImage(data.fields.asset);
};
